<template>
  <div class="p-3">
    <div class="title">
      <h4>{{ $t("new_post_title") }}</h4>
    </div>
    <Textarea
      v-model="message"
      :placeholder="$t('new_post_placeholder')"
      class="mb-4 col-12 p-4"
      rows="5"
      auto-resize
    />
    <FileUploader
      ref="postFileUploader"
      :type="'post'"
      :uploader-id="'uploadFilesForPost'"
      :upload-url="$root.api.fileManagerSave"
      :textbtn="$t('publish')"
      class-img-upload="no_rounded"
      @files-uploaded="onFilesUploaded"
      @progress="setUploadProgress"
      @error="isLoading = false"
    />
    <div
      class="
        info-text info-blue
        p-2
        pl-3
        pr-3
        border-radius
        flex
        align-items-center
        mt-3
      "
    >
      <span>
        Ao clicar no botão <b>"Anexar ficheiros"</b> você poderá utilizar a sua
        câmara fotográfica para fazer carregamentos de fotos ou vídeos.
      </span>
    </div>
    <Dialog
      v-model:visible="isVisible"
      :style="{ width: '450px' }"
      :draggable="false"
      header="A mensagem é referente a algum processo?"
      class="p-fluid"
      modal
    >
      <div class="field">
        <label>Processo</label>
        <Dropdown
          v-model="selectedProcessId"
          :options="processes"
          placeholder="Selecione"
          scroll-height="400px"
          option-value="id"
          filter
          :filter-fields="['code', 'manager', 'client', 'name', 'phase']"
          data-key="id"
          empty-message="Não foram encontrados processos"
          show-clear
        >
          <template #option="slotProps">
            <div class="process-option">
              <div class="process-option__code">
                {{ slotProps.option.code || "-" }}
              </div>
              <div class="process-option__grid">
                <span class="process-option__item">
                  <small class="process-option__label">Gestor</small>
                  <span class="process-option__value">{{
                    slotProps.option.managerName || "-"
                  }}</span>
                </span>
                <span class="process-option__item">
                  <small class="process-option__label">Fase</small>
                  <span class="process-option__value">{{
                    slotProps.option.phaseName || "-"
                  }}</span>
                </span>
                <span class="process-option__item process-option__item--full">
                  <small class="process-option__label">Tipo de processo</small>
                  <span class="process-option__value">{{
                    slotProps.option.processTypeName || "-"
                  }}</span>
                </span>
              </div>
            </div>
          </template>
          <template #value="slotProps">
            <div v-if="slotProps.value">
              {{ processes.find((p) => p.id === slotProps.value).code }}
            </div>
            <span v-else>{{ slotProps.placeholder }}</span>
          </template>
        </Dropdown>
      </div>
      <template #footer>
        <Button label="Cancelar" icon="pi pi-times" @click="cancel" />
        <Button
          :loading="isLoading"
          label="Guardar"
          icon="pi pi-check"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import FileUploader from "../utils/FileUploader.vue";

export default {
  components: { FileUploader },
  props: { processId: { type: [String, Number], default: null } },
  emits: ["post-created"],
  data() {
    return {
      message: "",
      postId: null,
      isLoading: false,
      filesUploaded: [],
      filesPersisted: [],
      uploadProgress: 0,
      processes: [],
      isVisible: false,
      selectedProcessId: null,
    };
  },
  mounted() {
    if (!this.processId) {
      this.getProcesses();
    }
  },
  methods: {
    onFilesUploaded(files) {
      this.filesUploaded = files;
    },
    setUploadProgress(progress) {
      this.uploadProgress = progress;
    },
    validateInputs() {
      if (!this.message || this.message.length == 0) {
        this.$root.toastError("message_is_required");
      } else {
        !this.processId && this.processes && this.processes.length > 0
          ? (this.isVisible = true)
          : this.submit();
      }
    },
    submit() {
      this.isLoading = true;
      if (this.filesPersisted.length > 0) {
        this.createPostFiles();
      } else {
        this.createPost();
      }
    },
    createPost() {
      let parameters = {
        message: this.message,
        attachments: this.filesUploaded,
        processId:
          this.processId != null ? this.processId : this.selectedProcessId,
      };
      this.postId = null;
      this.$root
        .apiPost(this.$root.api.posts, parameters)
        .then((response) => {
          if (this.filesUploaded.length > 0) {
            this.postId = response.data.data;
            this.persistFile(response.data.data);
          } else {
            this.resetData();
            this.$root.toastSuccess(response.data.msg_code);
            this.$emit("post-created");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    persistFile() {
      this.filesUploaded.forEach((file) => {
        file.context = this.processId
          ? `process/${this.processId}/post/${this.postId}`
          : `post/${this.postId}`;
      });
      this.$root
        .apiPost(this.$root.api.fileManagerPersist, {
          files: this.filesUploaded,
        })
        .then((response) => {
          this.filesUploaded = [];
          response.data.data.forEach((file) => {
            if (!file.url.startsWith("tmp/")) {
              this.filesPersisted.push(file);
            }
          });
          this.createPostFiles();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    createPostFiles() {
      let parameters = {
        attachments: this.filesPersisted,
        postId: this.postId,
        notify: true,
      };
      this.$root
        .apiPost(this.$root.api.postFiles, parameters)
        .then((response) => {
          this.resetData();
          this.$root.toastSuccess(response.data.msg_code);
          this.$emit("post-created");
        })
        .catch((error) => {
          this.isLoading = false;
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    resetData() {
      this.isLoading = false;
      this.message = "";
      this.filesUploaded = [];
      this.postId = null;
      this.filesPersisted = [];
      this.isVisible = false;
      this.selectedProcessId = null;
      if (
        this.$refs.postFileUploader &&
        this.$refs.postFileUploader.resetUploader
      ) {
        this.$refs.postFileUploader.resetUploader();
      }
    },
    cancel() {
      this.isVisible = false;
      this.selectedProcessId = null;
    },
    getProcesses() {
      this.$root
        .apiGet(this.$root.api.processes)
        .then((response) => {
          const data = response && response.data ? response.data.data : null;
          this.processes = data && data.ongoing ? data.ongoing : [];
        })
        .catch((error) => {
          this.$root.toastError(error.response.data.msg_code);
        });
    },
  },
};
</script>

<style scoped>
.process-option {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.6rem 0.75rem;
  background: #f8fafc;
}

.process-option__code {
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.4rem;
}

.process-option__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.45rem 0.8rem;
}

.process-option__item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.process-option__item--full {
  grid-column: 1 / -1;
}

.process-option__label {
  color: #6b7280;
  font-size: 0.75rem;
  margin-bottom: 0.1rem;
}

.process-option__value {
  color: #1f2937;
  font-size: 0.875rem;
  line-height: 1.2rem;
  word-break: break-word;
}
</style>
